import { menu, home, announcement, common, gateway, userProfiles, resident, oneAppMessaging, serviceRequest, user, project } from './text-storage';
/**
 * @param {String} language now only support {TH, EN}
 */
export const textMenu = (language) => { return mapping(menu, language); };
export const textHome = (language) => { return mapping(home, language); };
export const textAnnouncement = (language) => { return mapping(announcement, language); };
export const textCommon = (language) => { return mapping(common, language); };
export const textGateway = (language) => { return mapping(gateway, language); };
export const textUserProfiles = (language) => { return mapping(userProfiles, language); };
export const textResident = (language) => { return mapping(resident, language); };
export const textProject = (language) => { return mapping(project, language); };
export const textOneAppMessaging = (language) => { return mapping(oneAppMessaging, language); };
export const textServiceRequest = (language) => { return mapping(serviceRequest, language); };
export const textUser = (language) => { return mapping(user, language); };

const mapping = (storage, language) => {
  let result = {};
  for (const key of Object.keys(storage)) {
    switch (language) {
      case 'TH':
        result[key] = storage[key].TH;
        break;
      case 'EN':
        result[key] = storage[key].EN;
        break;
    }
  }
  return result;
};
